import { withFieldHint } from "@/src/components/HighOrderComponents";
import { SelectCounterField } from "@/src/components/Fields/SelectCounterField";
import { useFieldDebouncedCallback } from "@/src/hooks/useFieldDebouncedCallback";
import { USE_SELECT_FIELD_UPDATE_DELAY } from "@/src/shared/const/delay";

const UserSelectCounterFieldWithHint = withFieldHint(SelectCounterField);

export function UserSelect(props: any) {
  const hints = props?.hint?.hintsList;
  // Persist to BE context so the value survives form reset on processInstance refetch (window focus).
  const debouncedUpdateField = useFieldDebouncedCallback(
    props.name,
    USE_SELECT_FIELD_UPDATE_DELAY,
    true,
  );

  return (
    <UserSelectCounterFieldWithHint
      {...props}
      hints={hints}
      onValueChange={debouncedUpdateField}
    />
  );
}